<script>
import _ from 'lodash'
export default {
    name: "CommonVnameItem",
    props: {
        name: {
            type: String,
            default: 'name'
        },
        labelWidth: {
            type: String,
            default: '80px'
        },
        labelAlign: String,
        nameClass: String,
        webkitLineClamp: [Number, String]
    },
    computed: {
        labelStyle () {
            const ret = {}
            const labelWidth = this.labelWidth
            if (labelWidth) {
                ret.width = labelWidth
            }
            const candidate = ['left', 'center', 'right']
            if (this.labelAlign && _.indexOf(candidate, this.labelAlign) >= 0) {
                ret.textAlign = this.labelAlign
            }
            return ret
        },
        contentStyle () {
            const ret = {}
            let wlc = _.toInteger(this.webkitLineClamp)
            if (wlc > 0) {
                ret.overflow = 'hidden'
                ret.textOverflow = 'ellipsis'
                ret.display = '-webkit-box'
                ret.webkitBoxOrient = 'vertical'
                ret.webkitLineClamp = wlc
            } else if (this.labelWidth) {
                ret.display = 'block'
                ret.paddingLeft = this.labelWidth
            }
            return ret
        }
    },
    data () {
        return {}
    }
}
</script>

<template>
    <p class="name-value-item clear">
        <span class="name" :style="labelStyle" :class="[nameClass || '']">{{name}}</span>
        <span class="text" :style="contentStyle">
            <slot></slot>
        </span>
    </p>
</template>

<style scoped>
.clear {}
.clear::before,
.clear::after {
    display: table;
}
.clear::after {
    content: "";
    clear: both;
}
.name-value-item {
    word-wrap: break-word;
    overflow: hidden;
    margin-top: 5px;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    text-align: left;
    word-break: break-all;
    color: #333333;
}
.name-value-item .name {
    color: #9B9B9B;
    display: block;
    float: left;
    width: 80px;
    padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
}
.name-value-item .text {
    color: #333333;
}
</style>